import { render, staticRenderFns } from "./AssessmentStatisticsModule.vue?vue&type=template&id=50d32ad4&scoped=true&"
import script from "./AssessmentStatisticsModule.vue?vue&type=script&lang=js&"
export * from "./AssessmentStatisticsModule.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentStatisticsModule.vue?vue&type=style&index=0&id=50d32ad4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d32ad4",
  null
  
)

export default component.exports